"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DROPDOWN_ITEM_CATEGORY_KEY = 'base';
exports.DROPDOWN_ITEM_PARENT_COMPONENT_KEY = 'contextMenu';
exports.DROPDOWN_ITEM_COMPONENT_KEY = 'dropdownItem';